function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M573.09913,755.43923c0,9.94112-91,11-203,18-111.89547,6.99346-203-8.05888-203-18s91.52422-29.94384,203-18C482.09913,749.43923,573.09913,745.4981,573.09913,755.43923Z",
  transform: "translate(-167.09913 -124.7686)",
  fill: "#e6e6e6"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M1001.14227,124.76968H760.5268A51.15014,51.15014,0,0,0,710.629,164.67029L589.05081,703.93756a41.34045,41.34045,0,0,0,38.29376,50.38233L874.699,766.507a54.61491,54.61491,0,0,0,56.43048-44.82745l68.96661-381.268,5.1308,1.466L1018.423,269.613l-5.28143-1.32038,19.251-106.42558a31.49276,31.49276,0,0,0-31.25025-37.09737Z",
  transform: "translate(-167.09913 -124.7686)",
  fill: "#3f3d56"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M792.20343,136.39487h-28.087a35.34865,35.34865,0,0,0-34.53619,27.81347L612.88181,699.07587a21.90335,21.90335,0,0,0,19.96737,26.52539l246.55414,16.15893a28.3668,28.3668,0,0,0,29.77277-23.27746l99.57953-552.8377a24.84575,24.84575,0,0,0-24.45227-29.25016h-26.645a11.72583,11.72583,0,0,0-11.32264,8.67741h0a10.35181,10.35181,0,0,1-9.99591,7.66063H809.84656a17.69522,17.69522,0,0,1-17.64313-16.33806Z",
  transform: "translate(-167.09913 -124.7686)",
  fill: "#fff"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M528.288,411.51338l21.73913,43.0372L615.028,484.10089c6.94151,11.73111,28.99935,12.629,30.60352,5.04275,1.79962-8.51058-26.78569-22.20865-26.78569-22.20865l-54.36819-36.77354-4.757-31.65725Z",
  transform: "translate(-167.09913 -124.7686)",
  fill: "#a0616a"
});

var _ref6 = /*#__PURE__*/React.createElement("polygon", {
  points: "363.753 575.559 359.744 607.632 382.997 609.236 385.402 575.559 363.753 575.559",
  fill: "#a0616a"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M534.05984,727.58969a62.96609,62.96609,0,0,1-5.73785-7.017c-3.33247-4.6115-6.28944,19.04434-6.28944,19.04434s-3.20726,9.6218-2.40545,14.43277,19.24375,4.811,22.451,4.00912,19.24371,0,19.24371,0h24.05464c20.84735-9.6218,0-16.03641,0-16.03641-6.41457-.80178-28.06376-20.84738-28.06376-20.84738l-4.81094-8.82c-3.20727-.80185-6.41457,11.22551-6.41457,11.22551Z",
  transform: "translate(-167.09913 -124.7686)",
  fill: "#2f2e41"
});

var _ref8 = /*#__PURE__*/React.createElement("polygon", {
  points: "303.617 575.96 299.607 608.033 322.86 609.637 325.266 575.96 303.617 575.96",
  fill: "#a0616a"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M473.92323,727.99054a62.963,62.963,0,0,1-5.73785-7.017c-3.33247-4.61149-6.28944,19.04434-6.28944,19.04434s-3.2073,8.82-2.40545,13.631,19.24374,4.81091,22.451,4.00912,19.24371.80186,19.24371.80186h24.05465c20.84734-9.62181,0-16.03641,0-16.03641-6.41457-.80185-28.06377-20.84738-28.06377-20.84738l-4.81094-8.82c-3.2073-.80185-6.41457,11.22551-6.41457,11.22551Z",
  transform: "translate(-167.09913 -124.7686)",
  fill: "#2f2e41"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M497.17613,493.85883c-3.20731,4.00905-1.60367,17.64-1.60367,17.64s-5.61276,44.10038-3.20731,48.1095-1.60363,7.21639-4.00912,12.82914-4.81093,19.24375-4.81093,19.24375c-13.631,11.22543-12.82914,62.542-12.82914,62.542L465.905,699.92706c1.60364,4.8109,24.05461,5.61275,27.26192,4.8109s12.82914-72.96579,12.82914-72.96579l21.64919-40.89291S526.04164,699.927,526.04164,704.738s21.64916,2.40549,26.46009,2.40549,4.81094-80.18218,4.81094-80.18218l4.81094-20.84738,25.65828-95.4168V499.47158l-4.00909-5.61275S500.38343,489.84978,497.17613,493.85883Z",
  transform: "translate(-167.09913 -124.7686)",
  fill: "#2f2e41"
});

var _ref11 = /*#__PURE__*/React.createElement("circle", {
  cx: 365.35709,
  cy: 162.22025,
  r: 24.85646,
  fill: "#a0616a"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "M544.88449,298.61525c-5.03845,11.21947-2.05506,26.89026,8.01821,44.1002l-40.89291-19.24371,6.41457-5.61275-1.60363-16.03644Z",
  transform: "translate(-167.09913 -124.7686)",
  fill: "#a0616a"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  d: "M544.88442,324.27367c5.355,3.18356,8.55833,9.03293,10.3972,14.98517a142.00888,142.00888,0,0,1,6.10242,33.92893l1.94227,34.47531L587.381,499.07073c-20.84734,17.64-32.87474,13.631-60.93843-.80186s-31.271,4.8109-31.271,4.8109-2.40549-.80178,0-3.20726,0,0-2.40545-2.40549,0,0,.80182-2.40548,0-.80179-.80182-1.60364,3.20727-8.01824,3.20727-8.01824L489.55878,425.303l-8.01821-84.993c9.62188-12.02733,36.88379-22.451,36.88379-22.451L543.28082,335.499c8.01821,3.20727,1.60364-9.62187,1.60364-9.62187Z",
  transform: "translate(-167.09913 -124.7686)",
  fill: "#c4b581"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  d: "M468.31047,391.22557l-3.20726,48.10929,40.8929,58.533c0,13.631,7.21639,16.83826,7.21639,16.83826a105.99181,105.99181,0,0,0,7.21638-13.631c4.00912-8.82-2.40545-16.0364-2.40545-16.0364l-28.06373-59.3348L501.987,396.03657Z",
  transform: "translate(-167.09913 -124.7686)",
  fill: "#a0616a"
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  d: "M481.94154,340.71086c-13.631,4.8109-16.03645,56.92931-16.03645,56.92931,16.03645-8.82,35.28016,5.61275,35.28016,5.61275s4.009-13.63092,8.82-31.271a30.64418,30.64418,0,0,0-6.41457-28.86559S495.57253,335.9,481.94154,340.71086Z",
  transform: "translate(-167.09913 -124.7686)",
  fill: "#c4b581"
});

var _ref16 = /*#__PURE__*/React.createElement("path", {
  d: "M509.60434,294.60613c3.16431-2.5315,7.48121,2.07,7.48121,2.07l2.53147-22.78327s15.82173,1.89865,25.94761-.63285,11.70808,9.17658,11.70808,9.17658a81.26392,81.26392,0,0,0,.31643-14.23954c-.63285-5.69581-8.86012-11.39166-23.41612-15.18885s-22.15043,12.65738-22.15043,12.65738C501.89671,270.72852,506.44,297.13762,509.60434,294.60613Z",
  transform: "translate(-167.09913 -124.7686)",
  fill: "#2f2e41"
});

var _ref17 = /*#__PURE__*/React.createElement("path", {
  d: "M932.12257,510.31325a2.02579,2.02579,0,0,0,2.06445-1.6377l55.28516-300.9165a2.00016,2.00016,0,0,0-1.94336-2.36133l-251.52588-2.93017H735.98a2.00988,2.00988,0,0,0-1.95215,1.5625L668.854,495.17946a1.99932,1.99932,0,0,0,1.854,2.43359Z",
  transform: "translate(-167.09913 -124.7686)",
  fill: "#e6e6e6"
});

var _ref18 = /*#__PURE__*/React.createElement("path", {
  d: "M713.2295,529.53493a.99826.99826,0,0,0-.97265.77344l-2.32276,9.95605a1.00024,1.00024,0,0,0,.90284,1.22461l131.23,9.32715a1.00907,1.00907,0,0,0,1.05273-.80664l2.23389-11.51856a.9991.9991,0,0,0-.92188-1.18847L713.29,529.53688C713.27,529.53591,713.24952,529.53493,713.2295,529.53493Z",
  transform: "translate(-167.09913 -124.7686)",
  fill: "#e6e6e6"
});

var _ref19 = /*#__PURE__*/React.createElement("path", {
  d: "M872.66554,587.80837a1.00366,1.00366,0,0,0,1.05078-.75782l2.84375-11.543a1.0011,1.0011,0,0,0-.90234-1.23731l-167.58594-11.7207a.98881.98881,0,0,0-1.02881.71289l-2.95508,9.97461a.99858.99858,0,0,0,.87842,1.28027Z",
  transform: "translate(-167.09913 -124.7686)",
  fill: "#e6e6e6"
});

var _ref20 = /*#__PURE__*/React.createElement("path", {
  d: "M863.66554,624.80837a1,1,0,0,0,1.05078-.75782l2.84375-11.543a1.0011,1.0011,0,0,0-.90234-1.23731l-167.58594-11.7207a.98865.98865,0,0,0-1.02881.71289l-2.95508,9.97461a.99858.99858,0,0,0,.87842,1.28027Z",
  transform: "translate(-167.09913 -124.7686)",
  fill: "#e6e6e6"
});

var _ref21 = /*#__PURE__*/React.createElement("path", {
  d: "M786.48146,688.283a.98887.98887,0,0,0,1.06445-.75391l6.0127-24.05078a1.00071,1.00071,0,0,0-.88623-1.24024l-102.916-8.65625a1.01827,1.01827,0,0,0-1.06006.7793l-5.12939,23.083a1.001,1.001,0,0,0,.88281,1.21289Z",
  transform: "translate(-167.09913 -124.7686)",
  fill: "#c4b581"
});

var SvgHeroImage = function SvgHeroImage(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "abc6f0fe-ac59-4901-a46a-93a5eed63bf8",
    "data-name": "Layer 1",
    width: 865.80173,
    height: 650.4628,
    viewBox: "0 0 865.80173 650.4628",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgHeroImage, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/heroImage.4d22569c.svg";
export { ForwardRef as ReactComponent };